import { DEFAULT_ARCHIVE_STATUSES, DEFAULT_LIVE_STATUSES } from '@/redux/modules/search/search.types';
import { getPriceGuideBaseUrl } from '../urls';

type CategoryNode = {
    categories?: CategoryNode[];
    id: string;
    parents?: { id: string }[];
    selected?: boolean;
};

const getParentPathForQuery = (category: CategoryNode) => {
    let categoryToQuery = '';
    if (category.selected && category.parents && category.parents.length > 0) {
        let parentsToQuery = '';
        category.parents.forEach((parent) => {
            parentsToQuery += `${parent.id}/`;
        });
        categoryToQuery = `${parentsToQuery}${categoryToQuery}`;
    }
    return categoryToQuery;
};

export const concatenatePath = <Category extends CategoryNode>(
    category: Category | undefined,
    categoryId: string | number
) => {
    if (!category) {
        return categoryId;
    }
    if (String(category.id) === String(categoryId)) {
        let categoryToQuery = category.id;
        categoryToQuery = `${getParentPathForQuery(category)}${categoryToQuery}`;

        return categoryToQuery;
    }
    const nextCategory = findCategoryContainingSomeCategoryId(categoryId, category.categories);

    return `${category.id}/${concatenatePath(nextCategory, categoryId)}`;
};

export const findCategoryContainingSomeCategoryId = <Category extends CategoryNode>(
    categoryId: string | number,
    categories: Category[]
): Category | undefined => {
    if (!categories) {
        return undefined;
    }
    const directMatch = categories.find((c) => String(c.id) === String(categoryId));
    if (directMatch) {
        return directMatch;
    }
    return categories.find((c) => findCategoryContainingSomeCategoryId(categoryId, c.categories ?? []));
};

export const translateStatus = (queryParams: any, pathname: string) => {
    let status = DEFAULT_LIVE_STATUSES;

    if (queryParams.status === 'archive' || (pathname && pathname.includes(getPriceGuideBaseUrl()))) {
        status = DEFAULT_ARCHIVE_STATUSES;
    }

    return status;
};

export const sortCountryFacets = (countryFacets: any) => {
    return countryFacets.sort((a, b) => {
        if (a.name > b.name) {
            return 1;
        }
        if (a.name < b.name) {
            return -1;
        }
        return 0;
    });
};
